import { useState } from "react";

import { ArrowDropDown, FilterList } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";

import { NotificationFilterLabel } from "./NotificationFilterLabel";
import { NotificationFilter } from "./types";

import type { NotificationFilterSelectorProps } from "./types";

export function NotificationFilterMenu(props: NotificationFilterSelectorProps) {
  const { filter, onFilterChange, counts } = props;
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);

  const handleSelect = (option: NotificationFilter) => {
    onFilterChange(option);
    setAnchorElement(null);
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<FilterList />}
        endIcon={<ArrowDropDown />}
        onClick={(event) => setAnchorElement(event.currentTarget)}
      >
        <NotificationFilterLabel
          option={filter}
          count={counts[filter]}
          isActive
        />
      </Button>
      <Menu
        anchorEl={anchorElement}
        open={anchorElement !== null}
        onClose={() => setAnchorElement(null)}
      >
        {Object.values(NotificationFilter).map((option) => (
          <MenuItem
            key={option}
            selected={option === filter}
            onClick={() => handleSelect(option)}
          >
            <NotificationFilterLabel
              option={option}
              count={counts[option]}
              isActive={option === filter}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
